<template>
    <div :id="product.wp_slug" class="tool-box podcast-player-box flex">
        <div class="tool-download flex">
            <img
                class="product-logo"
                :src="product.image_url"
                :alt="product.name"
            >
            <a class="btn" :href="product.package_url"><i class="far fa-download" />Download WordPress Plugin</a>
            <div class="changelog">
                version {{ product.version }} (<a href="#" @click.prevent="toggleChangelogModal">changelog</a>)
            </div>
        </div>
        <div class="tool-description">
            <h3>{{ product.name }}</h3>
            <p> {{ product.description }}</p>
            <div
                v-if="groupedFeatures[index]"
                class="tool-features flex"
            >
                <template v-for="( featureGroup, groupNumber ) in groupedFeatures[index]">
                    <ul
                        :key="groupNumber"
                    >
                        <li
                            v-for="feature in featureGroup"
                            :key="feature.name"
                            :class="{ 'pro-feature': feature.pro && !user.pro }"
                        >
                            {{ feature.name }}
                        </li>
                    </ul>
                </template>
            </div>
            <p
                class="slogan"
                :class="{ 'slogan-free': !user.pro }"
            >
                <template
                    v-if="!product.has_pro_features"
                >
                    Pro features are coming soon!
                </template>
                <template v-else-if="product.has_pro_features && !user.pro">
                    <a
                        class="upgrade-link arrow-link"
                        href="#"
                        @click="openUpgradeModal"
                    >
                        Upgrade to Pro to access all {{ product.name }} features <i class="far fa-long-arrow-right" />
                    </a>
                </template>
            </p>
        </div>
        <transition
            name="fade"
            mode="out-in"
        >
            <base-changelog-modal
                v-if="showChangelog"
                @close-modal="toggleChangelogModal"
            >
                <!-- eslint-disable vue/no-v-html -->
                <div v-html="product.changelog" />
                <!-- eslint-enable -->
            </base-changelog-modal>
        </transition>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import changelogModal from '@/mixins/changelogModal';

export default {
    mixins: [changelogModal],

    props: {
        product: {
            type: Object,
            default: () => ({}),
        },
        groupedFeatures: {
            type: Array,
            default: () => [],
        },
        index: {
            type: Number,
            default: 0,
        },
    },

    computed: mapState(['user']),

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens upgrade modal
         *
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeModalVisible: true });
        },
    },
};
</script>
